import { Injectable } from '@angular/core';

import { apiName } from "./data.service";
import { TipoLogradouro } from "./tipo-logradouro.model";
import { RestService } from "../../../../core/services/rest.service";

@Injectable()
export class TipoLogradouroApiService {

  constructor(
    private _restService: RestService
  ) { }

  onPost(object: TipoLogradouro, done: any) {
    this._restService.onPost(apiName, object, done);
  }

  onPut(object: TipoLogradouro, done: any) {
    this._restService.onPut(apiName, object, done);
  }

  onDelete(objectId: number, done: any) {
    this._restService.onDelete(apiName, objectId, done);
  }

  onGetAll(done: any) {
    var filter: any = {"order":"tipo","where":{"ativo":true}};
    this._restService.onGetPost(apiName, filter, done);
  }

  onGetById(objectId: number, done: any) {
    this._restService.onGetPostId(apiName, objectId, {}, done);
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/enderecos/tipos-logradouro/shared/tipo-logradouro-api.service.ts
 **/